import React, { useState, useEffect } from 'react';

import Select from 'react-select';

import ContractorSchedulingIndexTableRow from './ContractorSchedulingIndexTableRow';

import Button from 'CommonComponents/Button';

export default function ContractorSchedulingIndexTable(props) {
    const [contractorPackChildren, setContractorPackChildren] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const selectAllVenuesOptions = [
        { value: 'all_venues', label: $t('All Venues') },
        { value: 'custom_venues', label: $t('Custom Venues') },
    ];

    const [selectAllVenues, setSelectAllVenues] = useState({
        value: 'all_venues',
        label: $t('All Venues'),
    });

    const selectAllDepartmentsOptions = [
        { value: 'all_departments', label: $t('All Departments') },
        { value: 'custom_departments', label: $t('Custom Departments') },
    ];

    const [selectAllDepartments, setSelectAllDepartments] = useState({
        value: 'all_departments',
        label: $t('All Departments'),
    });

    const [includeDepartments, setIncludeDepartments] = useState({});
    const [includeVenues, setIncludeVenues] = useState({});

    const [departments, setDepartments] = useState([]);
    const [venues, setVenues] = useState([]);

    useEffect(() => {
        axios
            .get(props.venuesUrl)
            .then((res) => {
                setVenues(res.data);
                setIsLoading(false);
            })
            .catch((error) => {
                setVenues([]);
                setIsLoading(false);
            });

        axios
            .get(props.departmentsUrl)
            .then((res) => {
                const { departments } = res.data;
                setDepartments(departments);
                setIsLoading(false);
            })
            .catch((error) => {
                setDepartments([]);
                setIsLoading(false);
            });
    }, []);

    useEffect(() => {
        fetchContractorScheduling();
        // Depend on the primitive `.value`, not the react-select option object,
        // which is a fresh identity on every change and would re-fetch needlessly.
    }, [includeVenues, includeDepartments, selectAllVenues.value, selectAllDepartments.value]);

    const fetchContractorScheduling = () => {
        setIsLoading(true);

        const departmentsToInclude = Object.keys(includeDepartments)
            .filter((departmentId) => includeDepartments[departmentId])
            .toString();

        const venuesToInclude = Object.keys(includeVenues)
            .filter((venueId) => includeVenues[venueId])
            .toString();

        axios
            .get(
                `${props.contractorSchedulingCreateUrl}?${selectAllVenues.value !== 'all_venues' ? `venues=${venuesToInclude}&` : ``}${
                    selectAllDepartments.value !== 'all_departments' ? `departments=${departmentsToInclude}` : ``
                }`,
            )
            .then((res) => {
                setContractorPackChildren(res.data.packChildrenExpenses);
                setIsLoading(false);
            })
            .catch((error) => {
                setContractorPackChildren([]);
                setIsLoading(false);
            });
    };

    const changeIncludeDepartments = (e, key) => {
        const inc = { ...includeDepartments };
        inc[key] = inc[key] ? 0 : 1;
        setIncludeDepartments(inc);
    };

    const changeIncludeVenues = (e, key) => {
        const inc = { ...includeVenues };
        inc[key] = inc[key] ? 0 : 1;
        setIncludeVenues(inc);
    };

    const onChangeSelectAllVenues = (option) => {
        setSelectAllVenues(option);
    };

    const onChangeSelectAllDepartments = (option) => {
        setSelectAllDepartments(option);
    };

    return (
        <div className="table__card">
            <form method="POST" action={window.contractorSchedulingStoreUrl}>
                <input type="hidden" name="_token" value={window.csrfToken} />

                <div className="tw-flex tw-flex-col tw-gap-1">
                    <div className="tw-flex tw-justify-end">
                        <Button type="submit" className="button primary">
                            {$t('Generate Report')}
                        </Button>
                    </div>

                    <div className="tw-w-full tw-items-start">
                        <label htmlFor="select_venues">{$t('Venues')}</label>
                        <Select
                            name="select_all_venues"
                            options={selectAllVenuesOptions}
                            onChange={onChangeSelectAllVenues}
                            defaultValue={{
                                value: 'all_venues',
                                label: $t('All Venues'),
                            }}
                            value={selectAllVenues}
                            className="tw-w-full"
                        />
                        {selectAllVenues.value === 'custom_venues' && (
                            <div className="tw-flex tw-flex-col tw-w-full tw-mt-3">
                                <h5 className="tw-text-blue tw-font-semibold tw-mb-1">{$t('Venues')}</h5>
                                <div className="tw-grid tw-grid-cols-6 max-md:tw-grid-cols-4 max-sm:tw-grid-cols-2">
                                    {venues.map((venue) => (
                                        <div key={`venue_${venue.id}`}>
                                            <div className="custom-control custom-switch">
                                                <input
                                                    name={`include_venues[${venue.id}]`}
                                                    className="include-column custom-control-input"
                                                    type="checkbox"
                                                    id={`include_venues[${venue.id}]`}
                                                    defaultChecked={!!includeVenues[venue.id]}
                                                    value={includeVenues[venue.id]}
                                                    onChange={(e) => changeIncludeVenues(e, venue.id)}
                                                />
                                                <label className="custom-control-label" htmlFor={`include_venues[${venue.id}]`}>
                                                    {venue.name}
                                                </label>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        <label htmlFor="select_departments">{$t('Departments')}</label>
                        <Select
                            name="select_all_departments"
                            options={selectAllDepartmentsOptions}
                            onChange={onChangeSelectAllDepartments}
                            defaultValue={{
                                value: 'all_departments',
                                label: $t('All Departments'),
                            }}
                            value={selectAllDepartments}
                            className="tw-w-full"
                        />
                        {selectAllDepartments.value === 'custom_departments' && (
                            <div className="tw-flex tw-flex-col tw-w-full tw-mt-3">
                                <h5 className="tw-text-blue tw-font-semibold tw-mb-1">{$t('Departments')}</h5>
                                <div className="tw-grid tw-grid-cols-6 max-md:tw-grid-cols-4 max-sm:tw-grid-cols-2">
                                    {departments.map((department) => (
                                        <div key={`department_${department.id}`}>
                                            <div className="custom-control custom-switch">
                                                <input
                                                    name={`include_departments[${department.id}]`}
                                                    className="include-column custom-control-input"
                                                    type="checkbox"
                                                    id={`include_departments[${department.id}]`}
                                                    defaultChecked={!!includeDepartments[department.id]}
                                                    value={includeDepartments[department.id]}
                                                    onChange={(e) => changeIncludeDepartments(e, department.id)}
                                                />
                                                <label className="custom-control-label" htmlFor={`include_departments[${department.id}]`}>
                                                    {department.name}
                                                </label>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="inbud-table_wrapper">
                        <table className="inbud-table">
                            <thead>
                                <tr className="text-blue">
                                    <th className="tw-min-w-40">{$t('Venue')}</th>
                                    <th className="tw-min-w-40">{$t('Department')}</th>
                                    <th className="tw-min-w-40">{$t('Pack')}</th>
                                    <th className="tw-min-w-40">{$t('Role')}</th>
                                    <th className="tw-min-w-32">{$t('Date')}</th>
                                    <th className="tw-min-w-32">{$t('Shift Number')}</th>
                                    <th className="tw-min-w-32">{$t('Start')}</th>
                                    <th className="tw-min-w-32">{$t('End')}</th>
                                    <th className="tw-min-w-32">{$t('Hours')}</th>
                                    <th className="tw-min-w-32">{$t('Rate per hour')}</th>
                                    <th className="tw-min-w-32">{$t('Total Cost')}</th>
                                </tr>
                            </thead>
                            {!isLoading && Object.values(contractorPackChildren).length > 0 && (
                                <tbody>
                                    {Object.values(contractorPackChildren).map((packChildVenue) => {
                                        return <ContractorSchedulingIndexTableRow key={`venue-${packChildVenue.venue_id}`} packChildVenue={packChildVenue} />;
                                    })}
                                </tbody>
                            )}
                            {isLoading && (
                                <tbody>
                                    <tr>
                                        <td colSpan="11">Loading...</td>
                                    </tr>
                                </tbody>
                            )}
                            {!isLoading && Object.values(contractorPackChildren).length === 0 && (
                                <tbody>
                                    <tr>
                                        <td colSpan="11">
                                            <a className={'mr-3 font-italic'}>No Pack Children found</a>
                                        </td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                    </div>
                </div>
            </form>
        </div>
    );
}
